




































































































































import config from '@/config';
import Vue from 'vue';
import { api } from '@/services/api';
import { mapState } from 'vuex';
import { relativeTime } from '@antriver/vue-site-utils/src/filters';
import { showAlert } from '@/utils/alert';

export default Vue.extend({
    name: 'VerificationView',

    data() {
        return {
            loading: true,
            emailVerification: null,
            defaultAvatarUrl: config.defaultAvatarUrl,

            // Will become true when the verification is complete.
            isVerified: false,

            createVerificationForm: {
                email: null,
                loading: false,
            },

            existingVerificationForm: {
                loading: false,
                resent: false,
            },
        };
    },

    computed: {
        ...mapState('auth', [
            'currentUser',
        ]),

        verificationSentAt() {
            if (this.emailVerification) {
                if (this.emailVerification.resentAt) {
                    return `${relativeTime(this.emailVerification.resentAt)} ago`;
                }
                return `${relativeTime(this.emailVerification.createdAt)} ago`;
            }

            return null;
        },
    },

    mounted() {
        api
            .get(
                'email-verifications',
            )
            .then((response) => {
                if (response.isVerified) {
                    this.isVerified = true;
                } else {
                    this.emailVerification = response.emailVerification || null;
                }
            })
            .catch(() => {
                this.emailVerification = null;
            })
            .finally(() => {
                this.loading = false;
            });

        if (this.$root.echo) {
            // Listen on the PUBLIC channel that broadcasts user IDs that have recently verified.
            this.$root.echo
                .channel('email-verifications')
                .listen(
                    '\\Amirite\\Events\\EmailVerifiedEvent',
                    (event) => {
                        if (this.currentUser && event.userId && event.userId === this.currentUser.id) {
                            // This is the user ID we are listening for.
                            this.isVerified = true;
                        }
                    },
                );
        }
    },

    methods: {
        changeEmail() {
            this.emailVerification = null;
        },

        createVerification() {
            this.createVerificationForm.loading = true;
            api
                .post(
                    'email-verifications',
                    {
                        email: this.createVerificationForm.email,
                    },
                )
                .then((response) => {
                    this.emailVerification = response.emailVerification;
                })
                .catch(({ message }) => {
                    showAlert(message);
                })
                .finally(() => {
                    this.createVerificationForm.loading = false;
                });
        },

        resendVerification(emailVerificationId) {
            this.existingVerificationForm.loading = true;
            api
                .post(
                    `email-verifications/${emailVerificationId}/resend`,
                    {},
                )
                .then((response) => {
                    this.emailVerification = response.emailVerification;
                    this.existingVerificationForm.resent = true;
                    setTimeout(() => {
                        this.existingVerificationForm.resent = false;
                    }, 30000);
                })
                .catch(({ message }) => {
                    showAlert(message);
                })
                .finally(() => {
                    this.existingVerificationForm.loading = false;
                });
        },
    },
});

